var render = function render(){var _vm=this,_c=_vm._self._c;return _c('like-link',{attrs:{"likeLayout":_vm.likeLayout,"likeData":_vm.likeData}})
}
var staticRenderFns = []

export { render, staticRenderFns }